import { render } from "./object-card-new.vue?vue&type=template&id=2f790778"
import script from "./object-card-new.vue?vue&type=script&setup=true&lang=js"
export * from "./object-card-new.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/object/object-card/object-card-new.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f790778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f790778', __exports__)) {
    api.reload('2f790778', __exports__)
  }
  
  module.hot.accept("./object-card-new.vue?vue&type=template&id=2f790778", () => {
    api.rerender('2f790778', render)
  })

}


export default __exports__